module.exports = __webpack_public_path__ + "img/trash.6f74cc9f.png";